import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import * as ramda from 'ramda';
import entityComposition from '../../common/classes/entityComposition';
import OptionNestedPicker from './optionNestedPicker/optionNestedPicker';
import OptionSinglePicker from './optionSinglePicker';
const toOptions = entities => entities.map(entity => ({
  title: entity.name,
  identifier: entity.identifier,
  id: entity.id,
  allowsOther: !!entity.allowsOther
}));

// Mutates the given tree, adding groups of parents to it
const addToTree = (tree, group, id) => {
  if (tree.id === id) {
    if (!tree.options) {
      /* eslint-disable-next-line no-param-reassign */
      tree.options = [];
    }
    /* eslint-disable-next-line no-param-reassign */
    tree.options = tree.options.concat(toOptions(group));
    return true;
  }
  if (tree.options) {
    return tree.options.some(child => addToTree(child, group, id));
  }
  return false;
};
class OptionsTablePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      pickerType: null,
      /* eslint-disable-next-line react/no-unused-state */
      optionSetIDs: [] // Used in getDerivedStateFromProps
    };
  }
  static getDerivedStateFromProps(props, state) {
    const optionsTable = props.optionsTable;
    const reduxName = "".concat(optionsTable.charAt(0).toLowerCase()).concat(ramda.slice(1, Infinity, optionsTable));
    const optionSetIDs = state.optionSetIDs;
    const newIDs = props[reduxName] ? props[reduxName].list.map(_ref => {
      let id = _ref.id;
      return id;
    }) : [];
    const hasChanged = newIDs.length !== optionSetIDs.length || !newIDs.every(id => optionSetIDs.includes(id));
    if (props[reduxName].list.length === 0 || !hasChanged) {
      return state;
    }
    const isNested = (props[reduxName].list || []).some(child => child.parentID !== undefined);
    if (!isNested) {
      const transformed = props[reduxName].list.map((_ref2, index) => {
        let name = _ref2.name,
          identifier = _ref2.identifier;
        return {
          identifier,
          title: name,
          // The iPad does not use the sortOrder and instead sets _created
          // as the index of the item + 1
          _created: index + 1
        };
      });
      return {
        options: transformed || [],
        optionSetIDs: newIDs,
        pickerType: 'simple'
      };
    }
    const groups = groupBy(props[reduxName].list, g => g.parentID);
    const parentKeys = Object.keys(groups);
    const root = {
      id: 'null'
    };
    // Setting a sane cap for the tree creation loop - in the even bad data is present
    // (ie disabled parent but enabled child), web app will not be stuck in an infinite loop
    const saneCap = 1000;
    let iterator = 0;
    while (parentKeys.length > 0 && iterator < saneCap) {
      iterator += 1;
      const key = parentKeys.shift();
      const success = addToTree(root, groups[key], key);
      if (!success) {
        parentKeys.push(key);
      }
    }
    return {
      options: root.options || [],
      optionSetIDs: newIDs,
      pickerType: 'nested'
    };
  }
  componentDidMount() {
    const _this$props = this.props,
      _this$props$activeIss = _this$props.activeIssue,
      _this$props$activeIss2 = _this$props$activeIss === void 0 ? {} : _this$props$activeIss,
      reportID = _this$props$activeIss2.reportID,
      optionsTable = _this$props.optionsTable;
    const reduxName = "".concat(optionsTable.charAt(0).toLowerCase()).concat(ramda.slice(1, Infinity, optionsTable));
    /* eslint-disable-next-line react/destructuring-assignment */
    const entity = this.props[reduxName];
    /* eslint-disable-next-line react/destructuring-assignment */
    const entityActions = this.props["".concat(reduxName, "Actions")];
    entityActions.serverFilter({
      report: [reportID]
    }, entity.indexQuery);
  }
  render() {
    const _this$state = this.state,
      options = _this$state.options,
      pickerType = _this$state.pickerType;
    const newProps = _objectSpread(_objectSpread({}, this.props), {}, {
      label: null,
      options: JSON.parse(JSON.stringify(options)),
      verticalPadding: false
    });
    if (!pickerType) {
      return null;
    }
    return pickerType === 'nested' ? /*#__PURE__*/React.createElement(OptionNestedPicker, newProps) : /*#__PURE__*/React.createElement(OptionSinglePicker, newProps);
  }
}
OptionsTablePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  activeIssue: PropTypes.shape({}).isRequired,
  optionsTable: PropTypes.string.isRequired
};
export { OptionsTablePicker as UncomposedOptionsTablePicker };
export default entityComposition(OptionsTablePicker, ['issueItem', 'issueNDT', 'issueSeverity', 'issueStatus', 'currentState'], {
  activeIssue: state => state.issue.active
});